import { Injectable } from '@angular/core';
import { getKeyListData$ } from '@common/helper';
import { MListData } from '@common/interfaces';
import { SupportClass } from '@lib/components/support-class';
import { AswMasterService, CommonLibService } from '@lib/services';
import { filter, map, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SeatAttributeRequestService extends SupportClass {
  /**
   * コンストラクタ
   */
  constructor(private _common: CommonLibService, private _master: AswMasterService) {
    super();
  }

  destroy(): void {}

  /**
   * 必要なキャッシュを取得する
   */
  getCacheMaster$(): Observable<MListData[]> {
    return getKeyListData$(
      this._master.load([{ key: 'ListData_All', fileName: 'ListData_All' }], true).pipe(
        filter((masterData) => masterData instanceof Array<any>),
        map((masterData) => masterData[0])
      ),
      'PD_035',
      this._common.aswContextStoreService.aswContextData.lang
    );
  }
}
